import { importScheduleDialogViewState } from "../";
import { IImportScheduleJobResult } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setImportScheduleJobResult", function setImportScheduleJobResult(jobResult: IImportScheduleJobResult) {
    importScheduleDialogViewState().jobResult = jobResult;
});